// src/layout/ProfileSection.jsx
import { Menu } from "antd";
import { LogOut, ChevronDown } from "lucide-react";
import { formatName } from "../Utils/helperMethod";
import "./ProfileSection.css";


const getInitials = (name = "") => {
  return name
    .split(" ")
    .map(word => word[0])
    .join("")
    .toUpperCase();
};

const ProfileSection = ({ collapsed, userInfo, handleLogout }) => {
  const user = userInfo || {
    name: "Guest",
    subscription: "Free",
  };

  const initials = getInitials(user.name);

  const items = [
    {
      key: "profile",
      icon: (
        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-sm font-semibold text-white">
          {initials}
        </div>
      ),
      label: (
        <div className="flex items-center justify-between w-full">
          <div className="flex flex-col leading-tight">
            <span className="text-sm font-medium text-white">
              {formatName(user.name)}
            </span>
            <span className="text-[13px] text-gray-200">
              {user.subscription}
            </span>
          </div>

          {/* {!collapsed && (
            <ChevronDown className="w-4 h-4 text-gray-400 ml-2" />
          )} */}
        </div>
      ),
      children: [
        {
          key: "logout",
          icon: <LogOut className="w-4 h-4" />,
          label: <span className="text-sm">Logout</span>,
          onClick: handleLogout,
          className: "logout-menu-item",
        },
      ],
    },
  ];

  return (
    <div className="border-t border-gray-700 pt-2 pb-2">
      <Menu
        mode={"inline"}
        theme="dark"
        inlineCollapsed={collapsed}
        selectable={false}
        items={items}
        className="!bg-transparent !border-none"
        triggerSubMenuAction="click"
      />
    </div>
  );
};

export default ProfileSection;